import { useAuth } from '../context/AuthContext';
import { useOverride } from '../context/OverrideContext';

export const usePermission = () => {
    const { user } = useAuth();

    // We try to use OverrideContext if it's available in the tree
    // If not, we provide a fallback requirePermission that simply checks native permissions.
    let overrideContext: ReturnType<typeof useOverride> | undefined;
    try {
        overrideContext = useOverride();
    } catch {
        // Fallback for components outside OverrideProvider
    }

    const hasPermission = (permission: string): boolean => {
        if (!user) return false;

        // Optional: Allow Super Admin and Managers to bypass checks
        if (['super_admin', 'admin', 'manager', 'partner'].includes(user.role)) return true;

        return user.permissions?.includes(permission) || false;
    };

    const requirePermission = (permission: string, actionName: string, onSuccess: () => void) => {
        if (overrideContext) {
            overrideContext.requirePermission(permission, actionName, onSuccess);
        } else {
            // Fallback behavior if OverrideProvider is missing
            if (hasPermission(permission)) {
                onSuccess();
            } else {
                console.warn(`Permission denied for ${actionName} (${permission}) and OverrideProvider is not present.`);
            }
        }
    };

    return { hasPermission, requirePermission };
};
